.container {
    border-radius: 0.3rem;
    display: flex;
    color: white;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
}
